<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="molecules"
      class="elevation-10 pa-10"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t("molecule.title") }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            :label="$t('common.search')"
            single-line
            hide-details
          ></v-text-field>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="filterTypeMolecule">
            <v-select
              v-model="selectedMoleculeType"
              :label="$t('common.select')"
              :item-text="'name'"
              :item-value="'value'"
              :items="moleculeTypes"
              variant="underlined"
            ></v-select>
          </div>
          <v-spacer />
          <v-btn
            v-if="
              userStore.isWriter() &&
              ['/', '/molecule'].includes($router.currentRoute.fullPath)
            "
            color="primary"
            dark
            class="mb-2 d-none d-sm-flex"
            @click="addItem()"
          >
            {{ $t("molecule.button.add") }}
            <v-icon right dark> mdi-plus-circle</v-icon>
          </v-btn>
          <v-btn
            v-if="userStore.isWriter()"
            color="primary"
            dark
            class="d-flex d-sm-none"
            @click="addItem()"
          >
            <v-icon dark> mdi-plus-circle</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mx-2" @click="showItem(item)"> mdi-eye</v-icon>
        <v-icon
          v-if="userStore.isWriter()"
          small
          class="mx-2"
          @click="editItem(item)"
        >
          mdi-pencil</v-icon
        >
        <v-icon
          v-if="userStore.isWriter()"
          small
          class="mx-2"
          @click="deleteItem(item)"
        >
          mdi-delete</v-icon
        >
      </template>
    </v-data-table>
    <router-view></router-view>
  </v-container>
</template>

<script>
import router from "@/router";
import { useMoleculeStore } from "@/store/moleculeStore";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useUserStore } from "@/store/userStore";

export default {
  data: function () {
    return {
      store: useMoleculeStore(),
      userStore: useUserStore(),
      molecules: null,
      search: ref(""),
      moleculeTypes: [
        {
          name: this.$t("molecule.list.typeFilter.MOLECULE_STANDARD"),
          value: "MOLECULE_STANDARD",
        },
        {
          name: this.$t("molecule.list.typeFilter.MOLECULE_KOKUMI"),
          value: "MOLECULE_KOKUMI",
        },
      ],
      selectedMoleculeType: ref("MOLECULE_STANDARD"),
      headers: [
        { text: this.$t("molecule.list.header.id"), value: "id" },
        { text: this.$t("molecule.list.header.name"), value: "name" },
        { text: this.$t("molecule.list.header.casNumber"), value: "casNumber" },
        {
          text: this.$t("molecule.list.header.action"),
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  async beforeMount() {
    this.molecules = storeToRefs(this.store).molecules;
    if (["/", "/molecule"].includes(router.currentRoute.path)) {
      await this.store.getMolecules({ type: this.selectedMoleculeType });
    }
  },

  props: {
    title: String,
  },
  watch: {
    selectedMoleculeType: async function () {
      await this.store.getMolecules({ type: this.selectedMoleculeType });
    },
  },
  methods: {
    addItem() {
      this.store.$reset();
      router.push({ path: "/molecule/add" });
    },

    showItem(item) {
      router.push(`/molecule/${item.id}`);
    },

    editItem(item) {
      this.store.$reset();
      router.push(`/molecule/edit/${item.id}`);
    },

    deleteItem(deleteItem) {
      if (confirm(this.$t("molecule.delete.confirm"))) {
        this.store.deleteMolecule(deleteItem.id);
      }
    },
  },
};
</script>

<style scoped>
.filterTypeMolecule ::v-deep .v-input__slot {
  margin-bottom: 0 !important;
}
.filterTypeMolecule ::v-deep .v-input__control {
  margin-top: 13px !important;
  margin-right: 15px !important;
}
</style>
